import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { CampaignViewAllTabsProps } from "./campaig-view-all-tabs-props";
import { CustomTabPanelComponent } from "../../../common/components";
import CampaignViewDetails from "./campaign-view-details/campaign-view-details";
import CampaignViewTimeline from "./campaign-view-timeline/campaign-view-timeline";
import CampaignViewDetailsViewAttachmentInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-attachment-info/campaign-view-details-view-attachment-info";
import CampaignViewDetailsViewActivitiesInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-activities-info/campaign-view-details-view-activities-info";
import CampaignViewDetailsViewLeadsInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-leads-info/campaign-view-details-view-leads-info";
import "./campaign-view.scss";
import CampaignViewDetailsViewContactInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-contact-info/campaign-view-details-view-customer-info";
import CampaignEmailInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-email/campaign-email-info";
import CampaignSMSInfo from "./campaign-view-details/campaign-view-details-view/campaign-view-details-view-sms/campaign-sms-info";

const CampaignViewDetailsAllTabs: React.FC<CampaignViewAllTabsProps> = ({
  campaignDetails,
  selectedCampaignId,
  setLoading,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  setUploadedImage,
  uploadedImageFile,
  setUploadedImageFile,
  setRemoveImage,
  removeImage,
  fetchCampaignDetails,
  campaignId,
  onCampaignNameUpdate,
  resetImageUpload,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  viewAddFullInfoOpen,
  setViewAddFullInfoOpen,
  setViewTaskvalue,
  setCrumbMappingOption,
  permissions,
  setViewMeetingvalue,
  viewCallValue,
  setViewCallValue,
}) => {
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [indexValue, setIndexValue] = useState(0);
  const [updatedDate, setUpdatedDate] = useState<string | undefined>();

  const handleMainTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setIndexValue(newValue);
    setViewFullInfoOpen(false);
  };

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  return (
    <div className="campaigns-view-all-tabs">
      <div className="campaign-list-view-tab-edit">
        <div className="campaign-list-view-tab-section">
          <Box>
            <Tabs
              value={indexValue}
              onChange={handleMainTabChange}
              allowScrollButtonsMobile
              variant="scrollable"
            >
              <Tab label="Details" />
              <Tab label="Attachments" />
              <Tab label="Activities" />
              <Tab label="Email" />
              <Tab label="SMS" />
              <Tab label="Leads" />
              <Tab label="Customers" />
              <Tab label="Timeline" />
            </Tabs>
          </Box>
        </div>
      </div>
      <div>
        <CustomTabPanelComponent value={indexValue} index={0}>
          <CampaignViewDetails
            campaignDetails={campaignDetails}
            selectedCampaignId={selectedCampaignId}
            setLoading={setLoading}
            viewFullInfoOpen={viewFullInfoOpen}
            setViewFullInfoOpen={setViewFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchCampaignDetails={fetchCampaignDetails}
            onCampaignNameUpdate={onCampaignNameUpdate}
            resetImageUpload={resetImageUpload}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={1}>
          <CampaignViewDetailsViewAttachmentInfo
            setLoading={setLoading}
            campaignId={campaignId}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={2}>
          <CampaignViewDetailsViewActivitiesInfo
            campaignDetails={campaignDetails}
            setViewTaskvalue={setViewTaskvalue}
            setCrumbMappingOption={setCrumbMappingOption}
            permissions={permissions}
            setViewMeetingvalue={setViewMeetingvalue}
            setViewCallValue={setViewCallValue}
          />
        </CustomTabPanelComponent>

        <CustomTabPanelComponent value={indexValue} index={3}>
          <CampaignEmailInfo
            campaignDetails={campaignDetails}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            permissions={permissions}
            fetchCampaignDetails={fetchCampaignDetails}
          />
        </CustomTabPanelComponent>
         <CustomTabPanelComponent value={indexValue} index={4}>
          <CampaignSMSInfo
            campaignDetails={campaignDetails}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            permissions={permissions}
            fetchCampaignDetails={fetchCampaignDetails}
          />
        </CustomTabPanelComponent>

        <CustomTabPanelComponent
          value={indexValue}
          index={5}
          isCampaigns={true}
        >
          <CampaignViewDetailsViewLeadsInfo
            allCampaignData={selectedCampaignId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={6}>
          <CampaignViewDetailsViewContactInfo
            allCampaignData={selectedCampaignId}
            permissions={permissions}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={7}>
          <CampaignViewTimeline
            selectedCampaignId={selectedCampaignId}
            setLoading={setLoading}
            setUpdatedDate={setUpdatedDate}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        </CustomTabPanelComponent>
      </div>
    </div>
  );
};

export default CampaignViewDetailsAllTabs;
